<template>
  <OACard class="OAHeader">
    <slot></slot>
    <form-component :form-data="formData" ref="formData" label-width="10px">
      <el-col :span="4" class="pull-right text-right">
        <el-button type="primary" @click="handleSearch" size="medium">查询</el-button>
        <el-button type="warning" @click="handleReset" size="medium">重置</el-button>
      </el-col>
    </form-component>
  </OACard>
</template>

<script>
  import formComponent from "@/components/formComponents/form-component";
  import OACard from "@/components/OACard/OACard";
  import {
    getValue
  } from "@/common/util.js";
  export default {
    props: ["formData"],
    components: {
      formComponent,
      OACard
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {
      handleSearch() {
        let data = getValue(this.formData);
        this.$emit("search", data);
      },
      handleReset() {
        _.map(this.formData, item => {
          if (item.value != undefined) {
            item.value = undefined;
          }
        });
        this.handleSearch();
      }
    }
  };

</script>
<style lang="scss">
  .OAHeader {
    .form_combination .el-form .el-form-item {
      margin-bottom: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/OATable/OAHeader.vue